<template>
  <div class="nickname page" :style="{backgroundImage: 'url(' + this.publicPath + 'img/nickname/bg.jpg)'}">
    <!-- <div class="tip">请输入昵称</div> -->
    <div class="input-box">
      <!-- <input class="input" type="text" v-model.lazy="nickname" @change="change" placeholder="" /> -->
      <!-- <textarea class="input" type="text" v-model="nickname" maxlength="30" rows="1"></textarea> -->
      <div class="input" type="text" maxlength="30" rows="1">{{nickname}}</div>
    </div>
    <div class="btn-box">
      <button class="submit" @click="submitNickname">确定</button>
    </div>
    <div class="nickname-cloud" :style="{backgroundImage: 'url(' + this.publicPath + 'img/nickname/cloud.png)'}"></div>
    <div class="nickname-star" :style="{backgroundImage: 'url(' + this.publicPath + 'img/nickname/star.png)'}"></div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Nickname',
  components: {
    // HelloWorld
  },
  data () {
    return {
      nickname: '你',
      nicknameMaxLength: 20,
      headImage: ''
    }
  },
  mounted () {
    if (window.$wxuser) {
      // TODO 过滤昵称里的表情符号等，特殊字符
      this.nickname = window.$wxuser.nickname || ''
      this.headImage = window.$wxuser.headimgurl || ''
    }

    if (window._czc) window._czc.push(['_trackEvent', '2020年终盘点-打开昵称', 'pv', '', '', ''])
  },
  methods: {
    change (value) {
      // 监听输入框的变化
      if (this.nickname.length > this.nicknameMaxLength) {
        this.nickname = String(this.nickname).slice(0, this.nicknameMaxLength)
      }
    },
    submitNickname () {
      if (this.nickname.length > 0) {
        this.$router.replace({
          name: 'Memory',
          params: {
            nickname: this.nickname,
            headImage: this.headImage
          }
        })
      } else {
        this.$notice.showMessage({
          type: 'warning',
          message: '请输入昵称'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.nickname {
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: 50% 0;

  .input-box {
    position: absolute;
    top: 14.4rem;
    left: 4.2rem;
    z-index: 30;
    .input {
      outline: none;
      // margin: .72rem .56rem .0rem 1.6rem;
      margin: .74rem .8rem;
      border: solid 1px #ffffff;
      padding: 0;
      width: 9.5rem;
      height: 1.3rem;
      background-color: #ffffff;
      white-space: nowrap;
      text-align: center;
      line-height: 1.3rem;
      font-weight: bold;
      font-size: .9rem;
      resize: none;
      transition: border-color .3s ease;
      -webkit-transition: border-color .3s ease;
      &::placeholder {
        color: #bababa;
        font-size: .6rem;
      }
    }
  }

  input:-webkit-autofill, textarea:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white  inset !important;
  }
  input, textarea{
    outline-color: invert;
    outline-style: none;
    outline-width: 0px;
    border: none;
    border-style: none;
    text-shadow: none;
    -webkit-appearance: none;
    -webkit-user-select: text;
    outline-color: transparent;
    box-shadow: none;
    -webkit-tap-highlight-color:rgba(255,255,255,0);
  }

  .btn-box{
    position: absolute;
    top: 23.2rem;
    left: 6.2rem;
    z-index: 30;
    .submit {
      opacity: 0;
      border: 0;
      border-radius: 4px;
      width: 8rem;
      height: 3.4rem;
      background-color: #3090f0;
      font-size: 14px;
      color: #ffffff;
      transition: background-color .5s ease;
      -webkit-transition: background-color .5s ease;
    }
    // .submit:hover {
    //   outline: none;
    //   border: 0;
    // }
    // .submit:active {
    //   background-color: #2080e0;
    // }
  }
}
.nickname-cloud{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 15;
  width: 100%;
  height: 100%;
  min-height: 40rem;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: 50% 100%;
}
.nickname-star{
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 19;
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: 50% 0%;
}
</style>
